module.exports = __webpack_public_path__ + "media/images/crypto/3-99355c7d34a4cb6d585d7a652a4c7405.png";